export default {
  PENDING: 'PENDING',
  STARTED: 'STARTED',
  DONE: 'DONE',
  REMOVED: 'REMOVED',
  FAILED: 'FAILED',
}
